// src/pages/HomePage.js
import React from 'react';

// Import Section Components
import HeroSection from '../components/sections/HeroSection';
import CapabilitiesSection from '../components/sections/CapabilitiesSection';
import ProductsServicesSection from '../components/sections/ProductsServicesSection';
import AboutSection from '../components/sections/AboutSection';
import ContactSection from '../components/sections/ContactSection';

// Import Data
import { companyData } from '../data/companyData';

function HomePage() {
  return (
    <main>
      {/* Render Hero Section */}
      <HeroSection
        title={companyData.hero.title}
        subtext={companyData.hero.subtext}
        backgroundImageUrl={companyData.hero.backgroundImageUrl}
      />

      {/* Render Capabilities Section */}
      <CapabilitiesSection capabilities={companyData.capabilities}  />

      {/* Render Products & Services Section */}
      <ProductsServicesSection data={companyData.productsServices} />

      {/* Render About Us Section */}
      <AboutSection content={companyData.about.content} />

      {/* Render Contact Section */}
      <ContactSection email={companyData.contactEmail} />
    </main>
  );
}

export default HomePage;
